(function ($) {

    var $slider;


    this.init = function () {

        $slider = $(".header-slideshow-slider");

        if ($(".header-slideshow-slider-slide").length > 1) {

            this.HomepageSlider();

        } 
    };


    /****************************************************************
     HOMEPAGE BANNER
    ****************************************************************/
    this.HomepageSlider = function () {

        BuildHomepageSliderSlider();

        function BuildHomepageSliderSlider() {
            $slider.slick({
                dots: true,
                arrows: true,
                prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous Home Banner Slide" tabindex="0" role="button"><i class="fa-solid fa-angles-left"></i></button>',
                nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next Home Banner Slide" tabindex="0" role="button"><i class="fa-solid fa-angles-right"></i></button>',
                appendArrows: $(".header-slideshow-controls"),
                appendDots: $(".header-slideshow-dots"),
                dotsClass: "slickdots",
                slidesToShow: 1,
                autoplay: true,
                adaptiveHeight: false,
                autoplaySpeed: 6000,
                infinite: true, 
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            dots: false,
                            autoplay: false
                        }
                    }
                ]
            });
        }

        $slider.on("destroy", function () {
            activeSlider = false;
        });

        $(".header-slideshow .play").on("click", function () {
            $slider.slick("slickPlay");
            $(".header-slideshow .pause").css("display", "block");
            $(".header-slideshow .play").css("display", "none");
        });
        $(".header-slideshow .pause").on("click", function () {
            $slider.slick("slickPause");
            $(".header-slideshow .pause").css("display", "none");
            $(".header-slideshow .play").css("display", "block");
        });
        $(".slickdots button").click(function () {
            $slider.slick("slickPause");
            $(".header-slideshow .pause").css("display", "none");
            $(".header-slideshow .play").css("display", "block");
        });

        $(".header-slideshow .pause").css("display", "block");
        $(".header-slideshow .play").css("display", "none");

        $(".header-slideshow .play, .header-slideshow .pause").on("click", function () {


        });

        // 
        $(".header-slideshow-playpause").css("left", $(".header-slideshow-dots").width() + 20);

    }

    this.init();

})(jQuery);